const AdminIcon = () => {
    return (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16">
            <g isolation="isolate">
                <path
                    d="M10.05,15c.06,.31,.27,.75,.46,1H1.5c-.83,0-1.5-.67-1.5-1.5v-1.3c0-2.32,1.88-4.2,4.2-4.2,.9,0,1.33,.5,2.8,.5s1.9-.5,2.8-.5c.18,0,.48,.03,.66,.07-.17,.24-.35,.67-.41,.96-.08,0-.16-.03-.25-.03-.61,0-1.22,.5-2.8,.5s-2.19-.5-2.8-.5c-1.77,0-3.2,1.43-3.2,3.2v1.3c0,.28,.22,.5,.5,.5H10.05ZM3,4C3,1.79,4.79,0,7,0s4,1.79,4,4-1.79,4-4,4S3,6.21,3,4Zm1,0c0,1.66,1.34,3,3,3s3-1.34,3-3-1.34-3-3-3c-1.65,0-3,1.35-3,3Zm16,6.5v4c0,.83-.67,1.5-1.5,1.5h-6c-.83,0-1.5-.67-1.5-1.5v-4c0-.83,.67-1.5,1.5-1.5h.5v-1.5c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v1.5h.5c.83,0,1.5,.67,1.5,1.5Zm-1,0c0-.28-.22-.5-.5-.5h-6c-.28,0-.5,.22-.5,.5v4c0,.28,.22,.5,.5,.5h6c.28,0,.5-.22,.5-.5v-4Zm-5-1.5h3v-1.5c0-.83-.67-1.5-1.5-1.5s-1.5,.67-1.5,1.5v1.5Zm2.5,3.5c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1,1,.45,1,1Z"
                    fill="#7f7f7f"/>
            </g>
        </svg>
    );
}
export default AdminIcon;
